module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      "m-icon",
      ("m-icon--" + _vm.icon) ]
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [(_vm.icon === 'arrow-left') ? _c('path', {
    attrs: {
      "d": "M8.76 11l4.95 4.95a1 1 0 1 1-1.42 1.41l-5.65-5.65a1 1 0 0 1 0-1.42l5.65-5.65a1 1 0 0 1 1.42 1.41L8.76 11z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-next') ? _c('path', {
    attrs: {
      "d": "M18.194 11.988H1.07v-2h17.1L11.394 3.21l1.415-1.413L22 10.99l-.01.01.01.01-9.192 9.193-1.415-1.414 6.8-6.803z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-prev') ? _c('path', {
    attrs: {
      "d": "M3.806 12.09H20.93v-2H3.83l6.777-6.778-1.415-1.414L0 11.09l.01.01-.01.012 9.192 9.193 1.415-1.415-6.8-6.8z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-right') ? _c('path', {
    attrs: {
      "d": "M13.24 11L8.3 6.05a1 1 0 0 1 1.42-1.41l5.65 5.65a1 1 0 0 1 0 1.42l-5.65 5.65a1 1 0 0 1-1.42-1.41L13.24 11z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'carousel') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M3 3v16h6V3H3zM1 1h10v20H1V1zm12 0h5v20h-5V1zm2 18h1V3h-1v16zm4-18h2v20h-2V1z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'close') ? _c('path', {
    attrs: {
      "d": "M11 9L4.5 2.5 3 4l6.7 6.5L3 17.3l1.3 1.4L11 12l7 6.7 1.3-1.4-6.8-6.8L19 4l-1.3-1.6L11 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'code') ? _c('path', {
    attrs: {
      "d": "M12.825 16.675l1.75 1.75L22 11l-7.425-7.425-1.75 1.75L18.5 11l-5.675 5.675zm-3.65-11.35l-1.75-1.75L0 11l7.425 7.425 1.75-1.75L3.5 11l5.675-5.675z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'connect') ? _c('path', {
    attrs: {
      "d": "M19 5l-7 7-2-2 7-7h-6V1h10v10h-2V5zm0 9h2v7H7l-6-6V1h7v2H3v11l5 5h11v-5z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'download') ? _c('path', {
    attrs: {
      "d": "M5.437 5.5L3.72 7.215l7.285 7.285 7.285-7.284L16.573 5.5l-5.568 5.567L5.437 5.5zM1 18h20v2H1v-2z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "dropdown") ? _c('path', {
    attrs: {
      "d": "M9.08 9h3.84a1 1 0 0 1 .78 1.62l-1.92 2.4a1 1 0 0 1-1.56 0l-1.92-2.4A1 1 0 0 1 9.08 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'ellipsis') ? _c('path', {
    attrs: {
      "d": "M5.12 9l2.123 2.12-2.122 2.123L3 11.12 5.12 9zm6 0l2.123 2.12-2.122 2.123L9 11.12 11.12 9zm6 0l2.123 2.12-2.122 2.123L15 11.12 17.12 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "eye") ? _c('path', {
    attrs: {
      "d": "M11 19c-3.58 0-6.86-2.09-9.84-6.26a3 3 0 0 1 0-3.48C4.14 5.09 7.42 3 11 3s6.86 2.09 9.84 6.26a3 3 0 0 1 0 3.48C17.86 16.91 14.58 19 11 19zm0-3a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "eye-crossed") ? _c('path', {
    attrs: {
      "d": "M4.3 5.72l-2.5-2.5a1 1 0 1 1 1.42-1.41L20.2 18.78a1 1 0 0 1-1.41 1.41l-2.71-2.7a9.43 9.43 0 0 1-5.07 1.5c-3.58 0-6.86-2.08-9.84-6.25a3 3 0 0 1 0-3.49A20.02 20.02 0 0 1 4.3 5.72zm9.46 9.45l-1.47-1.46a3 3 0 0 1-4-4L6.83 8.24a5 5 0 0 0 6.93 6.93zM6.96 3.94A9.17 9.17 0 0 1 11 3c3.58 0 6.86 2.08 9.84 6.25a3 3 0 0 1 0 3.5 21.62 21.62 0 0 1-2.31 2.76l-2.82-2.82a5 5 0 0 0-6.4-6.4L6.96 3.94zM11.02 8A3 3 0 0 1 14 10.98L11.02 8z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'grid') ? _c('path', {
    attrs: {
      "d": "M3,3 L3,8 L8,8 L8,3 L3,3 Z M1,1 L10,1 L10,10 L1,10 L1,1 Z M12,1 L21,1 L21,10 L12,10 L12,1 Z M14,3 L14,8 L19,8 L19,3 L14,3 Z M1,12 L10,12 L10,21 L1,21 L1,12 Z M3,19 L8,19 L8,14 L3,14 L3,19 Z M12,12 L21,12 L21,21 L12,21 L12,12 Z M14,19 L19,19 L19,14 L14,14 L14,19 Z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'plus') ? _c('path', {
    attrs: {
      "d": "M12 10V4h-2v6H4v2h6v6h2v-6h6v-2h-6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'search') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M11.074 3.615l-3.71 1.537-1.537 3.71 1.537 3.71 3.71 1.537 3.71-1.54 1.536-3.71-1.536-3.71-3.71-1.537zm5.623-.376l2.33 5.62-2.33 5.623-5.623 2.33-5.624-2.33L3.12 8.86l2.33-5.62L11.074.91l5.623 2.33zM13.27 17.284l2.267-1.054 2.612 5.618-2.27 1.053-2.61-5.616z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-dribbble') ? _c('path', {
    attrs: {
      "d": "M21.028 11c0 .677-.07 1.354-.205 2.013-.132.643-.327 1.275-.583 1.88-.25.592-.56 1.164-.924 1.697-.358.53-.77 1.027-1.222 1.48-.453.45-.952.862-1.48 1.22-.536.36-1.11.67-1.702.923-.605.255-1.24.45-1.882.582-.66.136-1.338.205-2.017.205-.678 0-1.357-.07-2.016-.205-.644-.132-1.277-.327-1.882-.582-.593-.252-1.166-.562-1.7-.922-.53-.35-1.03-.77-1.482-1.22-.453-.45-.865-.95-1.223-1.48-.36-.53-.67-1.1-.923-1.69-.256-.6-.452-1.23-.585-1.88C1.068 12.36 1 11.68 1 11c0-.678.068-1.355.202-2.013.133-.644.33-1.277.585-1.88.252-.593.563-1.166.924-1.7.36-.53.77-1.025 1.23-1.48.45-.45.95-.86 1.48-1.218.54-.37 1.11-.68 1.7-.93.61-.26 1.24-.45 1.88-.58.66-.14 1.34-.2 2.02-.2.68 0 1.36.06 2.02.2.65.13 1.28.32 1.88.58.6.25 1.17.56 1.7.92.53.35 1.03.76 1.48 1.22.46.45.87.95 1.22 1.48.36.53.67 1.1.92 1.7.26.6.45 1.23.59 1.88.14.65.21 1.33.21 2.01zM7.365 3.276C4.98 4.4 3.2 6.596 2.645 9.24c.225 0 3.79.046 7.895-1.043-1.48-2.626-3.06-4.77-3.175-4.92zm3.884 6.236c-4.41 1.316-8.63 1.22-8.79 1.216 0 .09-.01.18-.01.272 0 2.194.83 4.194 2.19 5.706 0-.004 2.34-4.15 6.95-5.64.11-.038.22-.07.34-.103-.22-.485-.45-.972-.7-1.45zm5.41-4.92c-1.51-1.327-3.48-2.13-5.65-2.13-.7 0-1.37.083-2.02.238.13.172 1.73 2.3 3.19 4.982 3.22-1.208 4.44-3.06 4.46-3.09zm-4.14 7.786l-.06.018c-5.05 1.757-6.7 5.297-6.71 5.334 1.45 1.13 3.27 1.81 5.25 1.81 1.18 0 2.31-.24 3.34-.675-.13-.746-.63-3.36-1.83-6.484zm3.26 5.704c1.92-1.294 3.28-3.35 3.66-5.73-.18-.055-2.57-.812-5.33-.37 1.12 3.08 1.58 5.585 1.66 6.1zm-2.93-9.128c.19.407.39.822.56 1.238l.184.443c2.937-.37 5.832.252 5.955.277-.02-2.024-.744-3.882-1.944-5.337-.018.023-1.39 2.002-4.766 3.38z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-instagram') ? _c('path', {
    attrs: {
      "d": "M11 1c-2.715 0-3.056.012-4.122.06-1.065.05-1.792.218-2.428.465-.657.255-1.215.597-1.77 1.153-.557.556-.9 1.114-1.155 1.77-.248.637-.417 1.364-.465 2.428C1.013 7.943 1 8.284 1 11c0 2.716.012 3.056.06 4.122.05 1.065.218 1.792.465 2.427.256.65.597 1.21 1.153 1.77s1.114.9 1.77 1.15c.637.24 1.364.41 2.43.46 1.065.045 1.406.06 4.122.06s3.056-.015 4.122-.06c1.065-.05 1.792-.22 2.43-.468.656-.255 1.213-.598 1.77-1.154.555-.555.897-1.113 1.153-1.77.246-.636.415-1.363.465-2.428.047-1.068.06-1.408.06-4.124s-.013-3.058-.06-4.124c-.05-1.065-.22-1.79-.465-2.427-.256-.657-.598-1.215-1.154-1.77-.55-.556-1.11-.898-1.77-1.153-.63-.247-1.36-.416-2.43-.465C14.06 1.01 13.72 1 11 1zm-.896 1.802H11c2.67 0 2.987.01 4.042.058.975.044 1.504.207 1.856.344.467.18.8.398 1.15.748.35.35.566.683.748 1.15.137.352.3.88.344 1.856.048 1.054.06 1.37.06 4.04 0 2.668-.012 2.985-.06 4.04-.044.974-.207 1.503-.344 1.856-.18.466-.398.8-.748 1.148-.35.35-.683.567-1.15.748-.352.138-.88.3-1.856.345-1.054.048-1.37.058-4.04.058s-2.988-.01-4.042-.058c-.975-.045-1.504-.208-1.857-.345-.467-.18-.8-.398-1.15-.748-.35-.35-.567-.682-.748-1.15-.137-.35-.3-.88-.345-1.856-.047-1.054-.057-1.37-.057-4.04s.01-2.986.057-4.04c.045-.975.208-1.505.345-1.857.18-.47.398-.8.748-1.15.35-.35.683-.57 1.15-.75.353-.14.882-.3 1.857-.35.923-.04 1.28-.06 3.144-.06zm6.235 1.66c-.67 0-1.2.537-1.2 1.2 0 .663.53 1.2 1.2 1.2.66 0 1.2-.537 1.2-1.2 0-.662-.54-1.2-1.2-1.2zM11 5.866c-2.835 0-5.135 2.3-5.135 5.135 0 2.84 2.3 5.14 5.136 5.14 2.84 0 5.14-2.3 5.14-5.13s-2.3-5.132-5.13-5.132zm0 1.802c1.842 0 3.334 1.492 3.334 3.333 0 1.84-1.492 3.34-3.333 3.34-1.84 0-3.33-1.49-3.33-3.33 0-1.85 1.49-3.34 3.33-3.34z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-facebook') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M19.848 20.946H2.144c-.607 0-1.1-.49-1.1-1.098V2.144c0-.607.493-1.1 1.1-1.1h17.704c.607 0 1.098.493 1.098 1.1v17.704c0 .607-.49 1.098-1.098 1.098zm-5.07 0V13.24h2.586l.387-3.004h-2.97V8.32c0-.87.24-1.463 1.488-1.463h1.59v-2.69c-.274-.036-1.22-.12-2.317-.12-2.293 0-3.863 1.4-3.863 3.97v2.217H9.082v3.004h2.593v7.706h3.102z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-facebook') ? _c('path', {
    attrs: {
      "d": "M12.54 21V11h2.76l.37-3.45h-3.13V5.83c0-.9.09-1.38 1.38-1.38h1.73V1h-2.76C9.57 1 8.4 2.67 8.4 5.48v2.07H6.33V11H8.4v10h4.14z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'tick') ? _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9.017 13.475l8.268-8.267 1.768 1.767-10.03 10.03L9.017 17l-.005.007-5.993-5.993 1.765-1.768 4.23 4.23z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'form-error') ? _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 20C4.4772 20 0 15.5228 0 10S4.4772 0 10 0s10 4.4772 10 10-4.4772 10-10 10zM9 4v8h2V4H9zm0 10v2h2v-2H9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'logout') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M19.2 11.8H11a.8.8 0 0 1 0-1.6h8.2l-2.7-2.7a.8.8 0 0 1 1-1l4 4c.3.3.3.7 0 1l-4 4a.8.8 0 0 1-1-1l2.7-2.8zM14 2.2a.8.8 0 0 1 0 1.5H8c-.7 0-1.3.6-1.3 1.3v12c0 .7.6 1.3 1.3 1.3h6a.7.7 0 1 1 0 1.4H8A2.7 2.7 0 0 1 5.2 17V5c0-1.5 1.3-2.8 2.8-2.8h6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'circle-plus') ? _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M11 22a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm1-12V6a1 1 0 0 0-2 0v4H6a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2h-4z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "alert") ? _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M11 22a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-.64-9.24h1.28l.33-3.33V6.9h-1.95v2.52l.34 3.33zm.64 3.12a1.07 1.07 0 1 0 0-2.14 1.07 1.07 0 0 0 0 2.14z"
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3768dcd5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Icon.vue
// module id = 63
// module chunks = 3